import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth/guards/auth.guard';
import { LoginComponent } from './auth/containers/login/login.component';
import { HomeComponent } from 'app/modules/home/home.component';
import { PageErrorComponent } from 'app/modules/page-error/page-error.component';
import { AuditoriaLogsComponent } from 'app/modules/auditoria/components/auditoria-logs/auditoria-logs.component';

const appRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'auditoria', component: AuditoriaLogsComponent, canActivate: [AuthGuard], data: { breadcrumbs: 'Auditoria' } },
  { path: 'page-error', component: PageErrorComponent, canActivate: [AuthGuard] },

  // --- ROTAS EM LAZY LOADING ---
  {
    path: 'avaliacoes',
    loadChildren: () => import('app/modules/avaliacoes/avaliacoes.module').then(m => m.AvaliacoesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'cargos',
    loadChildren: () => import('app/modules/cargos/cargos.module').then(m => m.CargosModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'cargos-modelo',
    loadChildren: () => import('app/modules/cargos-modelos/cargos-modelos.module').then(m => m.CargosModelosModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'ciencias',
    loadChildren: () => import('app/modules/ciencias/ciencias.module').then(m => m.CienciasModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'clientes',
    loadChildren: () => import('app/modules/clientes/clientes.module').then(m => m.ClientesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'diagnosticonr1',
    loadChildren: () => import('app/modules/diagnosticonr1/diagnosticonr1.module').then(m => m.DiagnosticoNr1Module),
    canActivate: [AuthGuard]
  },
  {
    path: 'integracoes',
    loadChildren: () => import('app/modules/integracoes/integracoes.module').then(m => m.IntegracoesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'mensagens',
    loadChildren: () => import('app/modules/mensagens/mensagens.module').then(m => m.MensagensModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'selecionados',
    loadChildren: () => import('app/modules/selecionados/selecionados.module').then(m => m.SelecionadosModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'servicos',
    loadChildren: () => import('app/modules/servicos/servicos.module').then(m => m.ServicosModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'tipos-servicos',
    loadChildren: () => import('app/modules/tiposServicos/tipos-servicos.module').then(m => m.TiposServicosModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'usuarios',
    loadChildren: () => import('app/modules/usuarios/usuarios.module').then(m => m.UsuariosModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'webhook',
    loadChildren: () => import('app/modules/webhook/webhook.module').then(m => m.WebhookModule),
    canActivate: [AuthGuard]
  },
  

  { path: '**', redirectTo: '' },

];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

